import {dataTestId} from '@hconnect/uikit'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography
} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {useRestoreDepartment} from '../../hooks/upmEntityConfig/useRestoreDepartment'
import {useItemDetails} from '../../providers'

export const RestoreDepartmentPopup = () => {
  const {setDepartmentToRestore, departmentToRestore} = useItemDetails()
  const departmentText = departmentToRestore?.text

  const handleClose = () => {
    setDepartmentToRestore(undefined)
  }

  const {mutate: restoreDepartment} = useRestoreDepartment()

  const {t} = useTranslation()

  const handleRestoreDepartment = () => {
    if (departmentToRestore?.upmId === undefined) return
    restoreDepartment(departmentToRestore?.upmId, {
      onSuccess: handleClose
    })
  }

  return (
    <Dialog open onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('plantSetup.departmentConfig.restoreDepartment')}</DialogTitle>
      <DialogContent>
        <Typography>
          {t('plantSetup.departmentConfig.restoreDepartmentConfirmation', {departmentText})}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          {t('common.cancel')}
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          {...dataTestId('restore-department-btn')}
          onClick={handleRestoreDepartment}
        >
          {t('common.restore')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
